﻿import { config } from './../../../../assets/config';
import { Injectable } from '@angular/core';
import { DateForm } from '../../enums/dateFormat.enum';
import { debug } from 'util';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { months } from '../../enums/paths.enum';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
export const MGBrands = ['Mitsubishi','Renault','Dacia','Hongqi'];

@Injectable({
  providedIn: 'root'
})

export class CommonService {
  lang: any = environment.lang;
  redirectURL: string;
  constructor(private router: Router,
    private toastrService: ToastrService,
    private translate: TranslateService) { }

  appLanguage = environment.lang;


  public routerNavigation(nextRouteStep: string): void {
    // console.log(`${this.appLanguage}/${nextRouteStep}`);
    this.router.navigate([`${this.appLanguage}/${nextRouteStep}`]);

  }

  public changeDateFormat(data: any, dateFormat: string) {

    if (dateFormat === DateForm.ind_f1) {
      return data.day + '/' + data.month + '/' + data.year;
    } else if (dateFormat === DateForm.ind_f3) {
      return data.year + '-' + data.day + '-' + data.month;
    } else if (dateFormat === DateForm.ind_f4) {
      return data.year + '-' + data.month + '-' + data.day;
    } else if (dateFormat === DateForm.ind_f2) {
      return data.month + '/' + data.day + '/' + data.year;
    } else if (dateFormat === DateForm.nsg_f4) {
      return data.year + '-' + data.month + '-' + data.day;
    }
  }

  public getLocalStorage(keyValue: string): any {
    if (localStorage.getItem(keyValue) != null) {
      return JSON.parse(localStorage.getItem(keyValue));
    }

  }

  public getLocalStorageitem(keyValue: string): any {
    if (localStorage.getItem(keyValue) != null) {
      return localStorage.getItem(keyValue);
    }

  }

  public setLocalStorage(keyValue: string, data: any): void {
    if (typeof (data) === 'object') {
      localStorage.setItem(keyValue, JSON.stringify(data));
    } else {
      localStorage.setItem(keyValue, data);
    }
  }

  public removeLocalStorage(keyValue: string[]): boolean {
    // tslint:disable-next-line:no-shadowed-variable
    keyValue.forEach(element => {
      localStorage.removeItem(element);
    });
    return true;
  }

  public clearLocalStorage(): boolean {
    localStorage.clear();
    return true;
  }

  public getMonthName(monthNumber: any): string {
    return months.NO.months[monthNumber - 1];
  }

  public NavigatePage(actionName: string, queryParam?: string, source?: string) {
    this.toastrService.clear();
    if (queryParam != null && queryParam !== undefined && queryParam !== '') {
      if(source != null && source !== undefined && source !== '')
        this.router.navigate([`${this.appLanguage}/${actionName}`], { queryParams: { dealerName: queryParam, source: source } });
      else
        this.router.navigate([`${this.appLanguage}/${actionName}`], { queryParams: { dealerName: queryParam } });
    } else {
      this.router.navigate([`${this.appLanguage}/${actionName}`]);
    }
  }

  public getLocalStorageByKey(Keyvalue: string, key: string): any {
    if (localStorage.getItem(Keyvalue)) {
      return JSON.parse(localStorage.getItem(Keyvalue))[key];
    } else { return '0'; }
  }

  public getReturnURL(brandName: string, LicensePlateNo: string, modelName: string): string {
    this.redirectURL = config.redirectURL + '/?69=' + brandName + ' ' + modelName +
      '&70=' + LicensePlateNo +
      '&73=' + this.getLocalStorageByKey('customerData', 'MobileNo') +
      '&74=' + this.getLocalStorageByKey('customerData', 'Email') +
      '&72=' + this.getLocalStorageByKey('customerData', 'FirstName') + ' ' + this.getLocalStorageByKey('customerData', 'LastName') +
      '&76=';
    return this.redirectURL;
  }

  public getErrorMessage(msg: any) {
    this.translate.get(msg).subscribe(message => {
      this.toastrService.error(message);
    });
  }

  public getSuccessMessage(msg: any) {
    this.translate.get(msg).subscribe(message => {
      this.toastrService.success(message, '', { disableTimeOut: false, progressBar: true, timeOut: 3000 });
    });
  }

  public clearToaster(){
    this.toastrService.clear();
  }
  public formatDate(data: any) {
    if (data == null || data == '' || data == "") {
      return data;
    }
    else {
      var dd = data.getDate();
      var mm = data.getMonth() + 1;
      var y = data.getFullYear();
      if (mm < 10) {
        mm = '0' + mm;
      }
      if (dd < 10) {
        dd = '0' + dd;
      }
      return dd + '.' + mm + '.' + y;
    }
  }

  // change color according to brand
  public getBrandColorMitsubishi() {
    const MitsubishiParentClass = document.querySelector('.ns-mg-mitsubishi');
    const MitsubishiChildClass = document.querySelector('.ns-mg-mitsubishi.mt-5');
    if (MitsubishiParentClass.classList.contains('ns-mg-mitsubishi')) {
      MitsubishiParentClass.classList.remove('ns-mg-mitsubishi');
      MitsubishiParentClass.classList.add('ns-mg-renault');
    }
    if (MitsubishiChildClass.classList.contains('mt-5')) {
      MitsubishiChildClass.classList.remove('ns-mg-mitsubishi', 'mt-5');
      MitsubishiChildClass.classList.add('ns-mg-renault', 'mt-5');
    }
  }

  public getBrandColorMitsubishiWithOutChildClass() {
    const MitsubishiParentClass = document.querySelector('.ns-mg-mitsubishi');
    if (MitsubishiParentClass.classList.contains('ns-mg-mitsubishi')) {
      MitsubishiParentClass.classList.remove('ns-mg-mitsubishi');
      MitsubishiParentClass.classList.add('ns-mg-renault');
    }
  }

  public getCurrentMonth(): number {
    const DateObject = new Date();
    return DateObject.getMonth();
  }

  public isFreeService(brand: string, serviceGroupId: string): boolean{
    if(brand == 'Mitsubishi' && serviceGroupId == '42')
      return true;
    if(brand == 'Hongqi' && serviceGroupId == '51')
      return true;
    // if(brand == 'Renault' && serviceGroupId == '51')
    //   return true;
    return false;
  }
  
  public getBrandTheme(brand: string): string{
    if(MGBrands.some(x => x.toLocaleLowerCase() === brand))
      return brand;
    return 'default-brand';
  }

}
